import { z } from 'zod';

export const vehicleGroupSchema = z.object({
  vehicleGroupId: z.number().optional(),
  vehicleGroupName: z.string().optional(),
});

export const vehicleGroupsSchema = z.array(vehicleGroupSchema);

export type VehicleGroup = z.infer<typeof vehicleGroupSchema>;

export type VehicleGroups = z.infer<typeof vehicleGroupsSchema>;
